<div *ngIf="artists | async; let artists">
 	<span *ngFor="let artist of artists" class="artist-name" [routerLink]="['./../../member$/member', artist.$key]">
		{{ artist.lastname }} {{ artist.firstname }}
	</span>
</div>